/*
 * Classe que extende de Slick.Grid.DataView para gerenciar
 * os dados que serão exibidos na grid
 * 
 * @author: Adalto Junior adalto@sagaranatech.com
 * DATE: 16/07/2013
 * 
 */


Monet.Grid = Monet.Grid || {};

Monet.Grid.DataProvider = function (columns, options = {}, entity) {
    var dataProvider = new Slick.Data.DataView(options);

    dataProvider.data = [];
    dataProvider.columns = columns;
    dataProvider.showTotals = false;
    dataProvider.totals = {};
    dataProvider.entity = entity;
    dataProvider.arrayIds = [];

    var totalsMetadata = {
        cssClasses: "totals",
        columns: {}
    };

    if (typeof dataProvider.options !== "undefined" && typeof dataProvider.options.showTotals !== "undefined") {
        dataProvider.showTotals = dataProvider.options.showTotals;
    }

    // torna as colunas dos totais não editáveis
    if (dataProvider.showTotals) {
        for (var i = 0; i < columns.length; i++) {
            totalsMetadata.columns[i] = {
                editor: null
            };
        }
    }

    dataProvider.setData = function (data) {

        dataProvider.data = data;
        this.setItems(dataProvider.data);
        this.formatArrayIds();

    };


    dataProvider.formatTotals = function (callbackFormatTotals) {

        var error = null;

        try {

            if (typeof callbackFormatTotals !== "undefined") {

                callbackFormatTotals(this.columns, this.data);

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on format totals");
            error.console();

        }

    };

    dataProvider.formatArrayIds = function () {

        var data = this.data,
            dataLength = data.length,
            id = 0;

        for (var i = 0; i < dataLength; i++) {

            id = data[i].idOfObject;
            this.arrayIds.push(id);

        }

    };


    dataProvider.getRowIndexFromColumnAndValue = function (object) {

        var data = this.data,
            dataLength = data.length;

        for (var i = 0; i < dataLength; i++) {

            var value = data[i][object.column];

            if (value === object.value) {

                return i;

            }

        }

    };

    /*TODO: alterar para o service time updates usar o deleteItem do slick.data.dataview agora que não há mais problema de escopo*/
    dataProvider.deleteItemById = function (dataItemId) {

        var error = null,
            dataLength = 0;

        try {

            dataLength = this.data.length;

            if (typeof dataItemId !== "undefined") {

                for (var i = 0; i < dataLength; i++) {

                    if (this.data[i].id === dataItemId) {

                        this.data.splice(i, 1);
                        break;

                    }

                }

            } else {

                error = new Monet.Exception.ReturnError(this,
                    "Data item id is undefined");
                error.console();

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on delete item by id");
            error.console();

        }

    };

    return dataProvider;

};